import { createFileRoute, redirect } from '@tanstack/react-router';

/** What OS knows is a tab of Workspace details now (web-redesign-03 phase 7.2): an old link opens the tab. */
export const Route = createFileRoute('/_app/business/knows')({
  beforeLoad: () => {
    throw redirect({ to: '/business', search: { section: 'knows' }, replace: true });
  },
});
